import { SVGProps } from 'react';

export const SubscriptionsIcon = ({
  fill = '#0071CD',
  size = 16,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.66675 5.16667C9.66675 6.64 8.47341 7.83333 7.00008 7.83333C5.52675 7.83333 4.33341 6.64 4.33341 5.16667C4.33341 3.69333 5.52675 2.5 7.00008 2.5C8.47341 2.5 9.66675 3.69333 9.66675 5.16667ZM8.33341 5.16667C8.33341 4.43333 7.73341 3.83333 7.00008 3.83333C6.26675 3.83333 5.66675 4.43333 5.66675 5.16667C5.66675 5.9 6.26675 6.5 7.00008 6.5C7.73341 6.5 8.33341 5.9 8.33341 5.16667ZM3.00008 11.8333C3.13341 11.4133 4.71341 10.7133 6.30675 10.54L7.66675 9.20667C7.40675 9.18 7.21341 9.16667 7.00008 9.16667C5.22008 9.16667 1.66675 10.06 1.66675 11.8333V13.1667H7.66675L6.33341 11.8333H3.00008ZM9.98008 11.6133L13.4001 8.16667L14.3334 9.10667L9.98008 13.5L7.66675 11.1667L8.60008 10.2267L9.98008 11.6133Z"
      />
    </svg>
  );
};
